"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePop = exports.PopType = void 0;
var react_1 = __importStar(require("react"));
var usePortal_1 = require("./portal/usePortal");
var PortalContext_1 = require("./portal/PortalContext");
var Pop_1 = require("../components/Pop");
var Heading_1 = require("../components/Heading");
var PopType;
(function (PopType) {
    PopType["IN"] = "PopIn";
    PopType["OUT"] = "PopOut";
})(PopType = exports.PopType || (exports.PopType = {}));
var usePop = function () {
    var popContext = usePortal_1.usePortal(PortalContext_1.PortalContext);
    var shownPop;
    //Close pop on unmount
    react_1.useEffect(function () {
        return function () {
            close();
        };
    }, []);
    return {
        show: function (type, popProps, title, message, delayMs) {
            var pop;
            type === PopType.IN
                ? (pop = (react_1.default.createElement(Pop_1.PopIn, __assign({}, popProps),
                    react_1.default.createElement(Heading_1.Heading, { level: Heading_1.Heading.Level.H4, content: title }),
                    react_1.default.createElement("span", null,
                        " ",
                        message,
                        " "))))
                : (pop = (react_1.default.createElement(Pop_1.PopOut, __assign({}, popProps),
                    react_1.default.createElement(Heading_1.Heading, { level: Heading_1.Heading.Level.H4, content: title }),
                    react_1.default.createElement("span", null,
                        " ",
                        message,
                        " "))));
            shownPop = popContext.openPortal(pop);
            if (delayMs) {
                setTimeout(function () {
                    popContext.closePortal(shownPop);
                }, delayMs);
            }
        },
        close: function () {
            popContext.closePortal(shownPop);
        },
    };
};
exports.usePop = usePop;
//# sourceMappingURL=usePop.js.map